import { useLocation } from 'react-router-dom'

export default function useQueryParams() {
  const searchParams = new URLSearchParams(useLocation().search)
  return searchParams
}
